import { styled } from "@mui/material/styles";

export const StyledDatePickerContainer = styled("div")(() => ({
  position: "relative",
}));

export const StyledAdornmentContainer = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  right: "12px",
  transform: "translateY(-50%)",
  zIndex: 2,
}));
